// extracted by mini-css-extract-plugin
module.exports = {"alone_content":"alone_content--gY4Pr","alone_detail":"alone_detail--eJBv9","add_host_form":"add_host_form--C_8eG"};